module.exports = __webpack_public_path__ + "static/media/user-placeholder.96328e57.svg";